import {MI} from "../init";

import {MadnesObject} from "../libs/mi/MadnesObject";

/**
 * @abstract @constructor
 * @extends {MadnesObject}
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 * @returns {AbstractSymbol}
 * @param {?string=} name
 */
export function AbstractSymbol(symbolNum, reelX, reelY, name) {

	MadnesObject.call(this, name);

	/**
	 * @type {number}
	 */
	this._symbolNum;
	this.setSymbolNum(symbolNum);

	/**
	 * @type {string}
	 */
	this.symbolName = this.getSymbolName();

	this.reelPos = { 'x': reelX, 'y': reelY };

	/** @type {boolean} */
	this.temporary = false;

	this._blurred = false;

	/** @type {boolean} */
	this.locked = false;
};

AbstractSymbol.prototype = Object.create(MadnesObject.prototype);
AbstractSymbol.prototype.constructor = AbstractSymbol;

/** @abstract */
AbstractSymbol.prototype.clear = function() {};

/**
 * @param {number} x
 * @param {number} y
 * @abstract
 * @return {AbstractSymbol}
 */
AbstractSymbol.prototype.init = function(x, y) {};

/**
 * @abstract
 * @return {AbstractSymbol}
 */
AbstractSymbol.prototype.createSymbol = function() {};

/**
 * @abstract
 * @return {AbstractSymbol}
 */
AbstractSymbol.prototype.createBlurSymbol = function() {};

/**
 * @abstract
 * @param {boolean=} wild
 * @returns {AbstractSymbol}
 */
AbstractSymbol.prototype.createWinSymbol = function(wild) {};

/**
 * @abstract
 * @returns {Promise}
 */
AbstractSymbol.prototype.playWinAnim = function() {};

/**
 * @public
 * @returns {number}
 */
AbstractSymbol.prototype.getReelX = function() {
	return this.reelPos['x'];
};

/**
 * @returns {number}
 */
AbstractSymbol.prototype.getReelY = function() {
	return this.reelPos['y'];
};

AbstractSymbol.prototype.setReelX = function(x) {
	this.reelPos['x'] = x;
};

AbstractSymbol.prototype.setReelY = function(y) {
	this.reelPos['y'] = y;
};

/**
 * @param {number} num
 * @returns {undefined}
 */
AbstractSymbol.prototype.setSymbolNum = function(num) {
	if(typeof num === "undefined") {
		throw new Error("symbol num error");
	}

	this._symbolNum = num;
};

/**
 * @returns {number}
 */
AbstractSymbol.prototype.getSymbolNum = function() {
	return this._symbolNum;
};

/** @returns {string} */
AbstractSymbol.prototype.getSymbolName = function() {
	return AbstractSymbol.getSymbolByNum(this.getSymbolNum());
};

/**
 * @param {number} reelX
 * @param {number} reelY
 * @returns {AbstractSymbol}
 */
AbstractSymbol.prototype.setReelPos = function(reelX, reelY) {
	this.reelPos = { 'x': reelX, 'y': reelY };
	return this;
};

/**
 * @param {number} num
 * @returns {string}
 */
AbstractSymbol.getSymbolByNum = function(num) {
	return MI.getPictureConvert()[num];
};

/**
 * @param {string} symbol
 * @returns {number}
 */
AbstractSymbol.getNumBySymbolName = function(symbol) {
	return MI.getPictureConvert().indexOf(symbol);
};